import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
    constantStyles: {
        colorStyles: {
            white: '#FFFFFF',
            activeGray: '#F5F7FA',
            black: '#212121',
        },
    },
    gradients: {
        green: 'linear-gradient(#3B878C, #559CA0)',
        darkGreen: 'linear-gradient(#285C6E, #427E92)',
        lightToDark: 'linear-gradient(180deg, #0575E6 0%, #559CA0 0.01%, #094B50 79.91%, #004044 100%)',
    },
    colors: {
        v2: {
            light: {
                darkCyan: {
                    60: '#183638',
                    50: '#235154',
                    40: '#2F6C70',
                    30: '#629FA3',
                    20: '#89B7BA',
                    10: '#B1CFD1',
                    default: '#3B878C',
                },
                blueSapphire: {
                    60: '#10252C',
                    50: '#183742',
                    40: '#204A58',
                    30: '#537D8B',
                    20: '#7E9DA8',
                    10: '#A9BEC5',
                    default: '#285C6E',
                },
                green: {
                    60: '#274824',
                    50: '#3B6C37',
                    40: '#4E9049',
                    30: '#4E9049',
                    20: '#A1D29D',
                    10: '#C0E1BD',
                    default: '#62B45B',
                },
                yellow: {
                    60: '#624A20',
                    50: '#926E30',
                    40: '#C39340',
                    30: '#F6C673',
                    20: '#F8D496',
                    10: '#FBE3B9',
                    default: '#F4B850',
                },
                englishVermillion: {
                    60: '#521E1E',
                    50: '#7C2C2E',
                    40: '#A53B3D',
                    30: '#A53B3D',
                    20: '#E29294',
                    10: '#EBB7B7',
                    default: '#CE4A4C',
                },
                grayscale: {
                    100: '#2C2C2C',
                    90: '#3C3C3C',
                    80: '#4D4D4D',
                    70: '#5D5D5D',
                    60: '#7D7D7D',
                    50: '#8E8E8E',
                    40: '#9E9E9E',
                    30: '#CECECE',
                    20: '#DFDFDF',
                    10: '#EFEFEF',
                    white: '#FFFFFF',
                    default: '#1C1C1C',
                },
            },
        },
        light: {
            grayscale: {
                100: '#1C1C1C',
                200: '#605F5F',
                300: '#979797',
                400: '#C4C4C4',
                500: '#E1E1E1',
                600: '#F5F5F5',
            },
            blue: {
                D60: '#10252C',
                D40: '#183742',
                D20: '#204A58',
                baseLight: '#285C6E',
                L20: '#537D8B',
                L40: '#7E9DA8',
                L60: '#A9BEC5',
            },
            green: {
                D60: '#183638',
                D40: '#235154',
                D20: '#2F6C70',
                baseLight: '#3B878C',
                L20: '#629FA3',
                L40: '#89B7BA',
                L60: '#B1CFD1',
            },
            brightGreen: {
                D60: '#274824',
                D40: '#3B6C37',
                D20: '#4E9049',
                baseLight: '#62B45B',
                L20: '#81C37C',
                L40: '#A1D29D',
                L60: '#C0E1BD',
            },
            orange: {
                D60: '#624A20',
                D40: '#926E30',
                D20: '#C39340',
                baseLight: '#F4B850',
                L20: '#F6C673',
                L40: '#F8D496',
                L60: '#FBE3B9',
            },
            red: {
                D60: '#521E1E',
                D40: '#7C2C2E',
                D20: '#A53B3D',
                baseLight: '#CE4A4C',
                L20: '#D86E70',
                L40: '#E29294',
                L60: '#EBB7B7',
            },
            background: {
                primary: '#FFFFFF',
                secondary: '#ECF6F6',
                blue: '#F1FBFF',
                green: '#EFF7EF',
                orange: '#FEF8EE',
                red: '#FAEDED',
            },
        },
    },
    consoleColors: {
        dark: '#2C3D43',
        alert: '#A9283F',
        headsUp: '#FFEFD7',
        info: '#CCECFB',
        highlights: '#566469',
        subtitile: '#808080',
    },
    effectStyles: {
        light: {
            dropShadow: {
                1: '0px 1px 1px rgba(0, 0, 0, 0.06)',
                2: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06), 0px 1px 1px rgba(0, 0, 0, 0.08)',
                3: '0px 3px 5px rgba(0, 0, 0, 0.1), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 6px 10px rgba(0, 0, 0, 0.08)',
                4: '0px 11px 15px rgba(0, 0, 0, 0.1), 0px 9px 46px rgba(0, 0, 0, 0.06), 0px 24px 38px rgba(0, 0, 0, 0.04)',
            },
            innerShadow: {
                1: 'inset 0px 1px 1px rgba(0, 0, 0, 0.06)',
                2: 'inset 0px 1px 3px rgba(0, 0, 0, 0.1), inset 0px 2px 1px rgba(0, 0, 0, 0.06), inset 0px 1px 1px rgba(0, 0, 0, 0.08)',
            },
        },
    },
    spacing: {
        xs: 4,
        s: 8,
        m: 12,
        l: 16,
        xl: 32,
        xxl: 48,
        xxxl: 64,
    },
    typography: {
        regular: 'Mulish-Regular',
        medium: 'Mulish-Medium',
        semiBold: 'Mulish-SemiBold',
        bold: 'Mulish-Bold',
        extraBold: 'Mulish-ExtraBold',
    },
    breakpoints: {
        xs: '480px',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
};

export default theme;
